/*
 * @Author: EdwardYoung
 * @Date: 2017-07-25 23:09:58
 * @Last Modified by: EdwardYoung
 * @Last Modified time: 2017-09-01 15:56:03
 */

import axios from 'api/axios.js'
import {createApiHeader} from './createApiHeader.js'

async function postWxToken (id) {
  return new Promise((resolve, reject) => {
    window.yhsd.ready(function (sdk) {
      sdk.account.current(function (User) {
        createApiHeader(axios, User.res.customer)
        _postWxToken(id, User.res.customer).then((res) => {
          resolve(res.data.data)
        }).catch((err) => {
          reject(err.response.data.message)
        })
      })
    })
  })
}

/**
 * 发送WxToken
 */
function _postWxToken (token) {
  const url = `/v1/front/subscribe/${token}`
  return axios({
    method: 'POST',
    url: url
  })
}

export {postWxToken}



// WEBPACK FOOTER //
// ./src/api/postWxToken.js